<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 mb-2">
                        <div class="card">
                            <div class="card-body">
                                <div class="card-title">
                                    <p class="text-muted mb-0">
                                        <i :class="status == 'on' ? 'text-success' : 'text-danger'" class="mdi mdi-circle align-middle mr-1 "></i>Status {{status}}
                                    </p>
                                </div>
                                <div v-if="link != ''">
                                    <img v-if="!hls" :src="link" fluid alt="Cctv View" class="w-100" @error="imageError"/>
                                    <video-player v-else ref="videoPlayer"
                                    class="vjs-custom-skin"
                                    :src="link"
                                    :options="playerOptions"  />
                                </div>
                            </div>
                        </div>
                    </div>
                      <div class="col-12">
                        <div class="row">
                            <div class="col-md-6 mt-2">
                                <div class="card h-100">
                                    <div class="card-body">
                                        <h5 class="card-title font-weight-bolder">{{$t('detail-cctv.card-title.cctv-info')}}</h5>
                                        <div class="mb-0">
                                            <table class="table table-nowrap table-centered">
                                                <tbody>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="text-truncate font-size-12 m-0">{{$t('detail-cctv.td.cctv-name')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="text-truncate text-wrap font-size-12 m-0">
                                                                <span class="text-dark">{{cctv_name}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="text-truncate font-size-12 m-0">{{$t('detail-cctv.td.source')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="text-truncate text-wrap font-size-12 m-0">
                                                                <span class="text-dark">{{source}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="text-truncate font-size-12 m-0">{{$t('detail-cctv.td.category')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="text-truncate text-wrap font-size-12 m-0">
                                                                <span class="text-dark">{{category}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mt-2">
                                <div class="card h-100">
                                    <div class="card-body">
                                        <h5 class="card-title font-weight-bolder">{{$t('detail-cctv.card-title.district-info')}}</h5>
                                        <div class="mb-0">
                                            <table class="table table-centered">
                                                <tbody>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="font-size-12 m-0">{{$t('detail-cctv.td.district')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark">{{district}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="font-size-12 m-0">{{$t('detail-cctv.td.sub-district')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark">{{sub_district}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="font-size-12 m-0">{{$t('detail-cctv.td.address')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark">{{address}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                            <strong class="font-size-12 m-0">{{$t('detail-cctv.td.coordinate')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark">{{coordinate}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-4 mb-4">
                                <div class="card h-100">
                                    <div class="card-body">
                                        <h5 class="card-title font-weight-bolder">{{$t('detail-cctv.card-title.detail-info')}}</h5>
                                        <div class="mb-0">
                                            <table class="table ">
                                                <tbody>
                                                    <tr>
                                                        <td width="12%">
                                                            <strong class="font-size-12 m-0">{{$t('detail-cctv.td.created-at')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark">{{formatDate(created_at)}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td >
                                                            <strong class="font-size-12 m-0">{{$t('detail-cctv.td.updated-at')}}</strong>
                                                        </td>
                                                        <td>
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark">{{formatDate(updated_at)}}</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td >
                                                            <strong class=" font-size-12 m-0">{{$t('detail-cctv.td.link')}}</strong>
                                                        </td>
                                                        <td >
                                                            <h5 class="font-size-12 m-0">
                                                                <span class="text-dark text-wrap"><a :href="link" target="_blank" rel="noopener noreferrer">{{link}}</a></span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import CctvService from "@/helpers/cctv.service"
import { tableData } from '../personal/dataAdvancedtable';
import moment from "moment";
import {gmapApi} from 'vue2-google-maps'
// import HLSCore from '@core-player/playcore-hls';
import VideoPlayer from '../../../components/widgets/video-player.vue'

export default {
    page: {
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, VideoPlayer },
    data() {
        return {
            backUrl: "/cctv",
            id: this.$route.params.id,
            title: this.$t('menuitems.cctv.text'),
            items: [
                {
                text: this.$t('menuitems.setting.text'),
                href: "#"
                },
                {
                text: this.$t('menuitems.cctv.text'),
                href: "/cctv"
                },
                {
                text: "Detail",
                active: true
                }
            ],
            cctv_name: "",
            source: "",
            category: "",
            address: "",
            district: "",
            sub_district: "",
            link: "",
            coordinate: "",
            status: "",
            created_at: "",
            updated_at: "",
            hls: false,
            playerOptions: {
                autoplay: true,
                controls: true,
                controlBar: {
                    timeDivider: false,
                    durationDisplay: false
                }
                // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
            }
        };
    },
    computed:{
        google: gmapApi, 
        player () {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        imageError(e){
            this.hls = true;
            console.log(e);
            setTimeout(()=>{
                this.playVideo(this.link)
            }, 1500)
        },
        getDetailCctv(){
            CctvService.detail(this.id)
            .then(response => {
                console.log(response);
                this.cctv_name = response.data.data.cctv_name
                this.source = response.data.data.source
                this.category = response.data.data.category
                this.address = response.data.data.address
                this.district = response.data.data.district
                this.sub_district = response.data.data.sub_district
                this.link = response.data.data.link
                this.coordinate = response.data.data.coordinate
                this.status = response.data.data.status
                this.created_at = response.data.data.created_at
                this.updated_at = response.data.data.updated_at
            })
            .catch(err => {
                console.log(err);
            });
        },
        formatDate(value){
            return moment(value).format("YYYY-MM-DD, hh:mm");
        },
        playVideo: function (source) {
            const video = {
                withCredentials: false,
                type: 'application/x-mpegurl',
                src: source
            }
            this.player.reset() 
            this.player.src(video)
            this.player.play()
        },
    },
    beforeMount(){
        this.getDetailCctv();
    },
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
</style>